import React, { useEffect, useState } from "react";
import { BackButton, EditButton } from "../../../../Components/Utils/Buttons";
import { Link, useLocation, useParams } from "react-router-dom";
import { NormalHeading } from "../../../../Components/Utils/Heading";
import Breadcrumb from "../../../../Components/Utils/Breadcrumb";
import { GetRole } from "../../../../Components/Utils/roles";
import axiosInstance from "../../../../Services/axiosCommon";
import ViewIcon from "../../../../Components/Icons/ViewIcon";

function ViewSuppliers() {
  const { suppliersViewId } = useParams();
  const location = useLocation();

  const pageIndex = location.state?.pageIndex;
  const searchQuery = location.state?.searchQuery;

  const stateData = location?.state?.data;
  const [store, setStore] = useState(stateData ? stateData : null);
  const initialProducts = stateData?.products
    ? stateData.products.split(", ").map((p) => p.trim())
    : [];
  const [productList, setProductList] = useState(initialProducts);
  const initialEmails = stateData?.emails
    ? stateData.emails.split(", ").map((p) => p.trim())
    : [];
  const [emailsList, setEmailsList] = useState(initialEmails);
  const initialServices = stateData?.services
    ? stateData.services.split(", ").map((p) => p.trim())
    : [];
  const [servicesList, setServicesList] = useState(initialServices);
  const [showValidation, setShowValidation] = useState(false);

  const [data, setData] = useState(stateData ? stateData : null);

  function getViewnew() {
    axiosInstance
      .get(`/vendors/${suppliersViewId}`)
      .then((res) => {
        let response = res.data?.data;
        setData(response);
        setStore(response);
        setProductList(
          response?.products
            ? response.products.split(", ").map((p) => p.trim())
            : [],
        );
        setEmailsList(
          response?.emails
            ? response.emails.split(", ").map((p) => p.trim())
            : [],
        );
        setServicesList(
          response?.services
            ? response.services.split(", ").map((p) => p.trim())
            : [],
        );
      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (!stateData) {
      getViewnew();
    }
  }, [suppliersViewId]);

  const [approval, setApproval] = useState(false);
  const [approvedStatus, setApprovedStatus] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [reason, setReason] = useState("");

  function getView() {
    axiosInstance
      .get(`/vendors/can-approve`)
      .then((res) => {
        setApproval(res.data?.data || false);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  function updateApprovalStatus(approvalStatus, rejectionReason = "") {
    const payload = { approvalStatus };
    if (rejectionReason) {
      payload.reason = rejectionReason;
    }

    axiosInstance
      .put(`/vendors/edit-approval/${suppliersViewId}`, payload)
      .then((res) => {
        if (res.data.status === true) {
          setStore({
            ...store,
            approvalStatus: approvalStatus,
            reason: res.data.data.reason,
          });
        }
        setApprovedStatus(approvalStatus);
        setShowPopup(false);
        setReason("");
      })
      .catch((error) => {
        console.error(error);
      });
  }

  useEffect(() => {
    getView();
  }, []);

  useEffect(() => {
    if (suppliersViewId) {
      setApprovedStatus(data?.approvalStatus || "");
    }
  }, [suppliersViewId, data]);

  const [showConfirm, setShowConfirm] = useState(false);

  const handleApproveClick = () => {
    setShowConfirm(true);
  };

  const confirmApproval = () => {
    // Call the approval function here
    updateApprovalStatus("approved");
    setShowConfirm(false);
  };

  const cancelApproval = () => {
    setShowConfirm(false);
  };

  const [isPopupOpenAccess, setIsPopupOpenAccess] = useState(false);

  const togglePopupAccess = () => {
    setIsPopupOpenAccess(!isPopupOpenAccess);
  };

  return (
    <div className="w-full h-full p-2 lg:px-4 ">
      <div className="w-full flex flex-row justify-between items-center gap-2 mb-3">
        <Breadcrumb
          items={[
            {
              name: "Suppliers",
              link: "/procurement/suppliers",
            },
            {
              name: "View Suppliers",
            },
          ]}
        />
        <div className="flex items-center gap-2 flex-shrink-0">
          <Link
            to={"/procurement/suppliers"}
            state={{
              currentPage: pageIndex,
              searchQuery: searchQuery != "" ? searchQuery : "",
            }}
          >
            <BackButton link={true} />
          </Link>
          <Link
            to={`/procurement/suppliers/edit/${suppliersViewId}`}
            state={{
              data: data,
              from: `/procurement/suppliers/view/${suppliersViewId}`,
            }}
          >
            <EditButton height="8" />
          </Link>
        </div>
      </div>
      <div className="w-full mx-auto md:h-[calc(100vh-145px)] bg-white rounded-md mt-4 overflow-y-auto p-2">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 mb-4">
          <NormalHeading title={data?.companyName} />
          <div className="flex flex-wrap items-center gap-2">
            <div className=" border border-[#048178] overflow-hidden rounded-md text-xs 2xl:text-sm flex items-center">
              <p className="px-2 py-[5px] text-[#048178]">Supplier Type :</p>{" "}
              <p className="bg-[#048178] text-white px-2 py-[5px]">
                {store?.type || "-"}
              </p>
            </div>
            {GetRole() && (
              <div>
                <button
                  className="bg-[#048178] px-2 py-[6px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                  onClick={togglePopupAccess}
                >
                  Accessible User
                </button>
              </div>
            )}
          </div>
        </div>
        <div className="w-full grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="w-full rounded-lg bg-white py-2 flex flex-col">
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Category
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.category || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Type
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.vendorType || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Assigned To
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.assignedToName || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Phone
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.phoneWithCC || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Email
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.email || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Website
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.website || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                TaxId
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.taxId || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Contact Person{" "}
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.contactPerson || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Designation
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.designation || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Contact Person Email
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.contactPersonEmail || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Contact Person Mobile
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.cPMobileWithCC || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Performance Ratings
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.performanceRating || "-"}
              </p>
            </div>
          </div>

          <div className="w-full rounded-lg bg-white py-2 flex flex-col">
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Payment Terms
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.paymentTerms || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Delivery Terms
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.deliverTerms || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Street Address Line 1
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.address1 || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Street Address Line 2
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.address2 || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                City
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.city || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                State / Province
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.state || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Postal / Zip Code
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.postalCode || "-"}
              </p>
            </div>
            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Country
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.country || "-"}
              </p>
            </div>

            <div className="odd:bg-white even:bg-slate-50 w-full flex px-2 items-center">
              <p className="w-1/3 py-2 text-xs font-medium text-[#111537] shrink-0">
                Comments
              </p>
              <p className="w-2/3 py-2 text-xs text-[#606279] break-words">
                {data?.comments || "-"}
              </p>
            </div>
          </div>
        </div>
        <p className="w-full pb-2 pt-4 px-2 text-sm font-medium text-[#111537]">
          Products , Services & Emails
        </p>
        <div className="border-t border-[1px] border-slate-200/60 border-solid w-full mb-2"></div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="w-full flex flex-col">
            <p className="w-full pb-2 pt-1 px-1 text-xs font-medium text-[#111537]">
              Products
            </p>
            <div className="w-full h-32 rounded-md p-1 flex flex-col border border-solid overflow-y-auto">
              {productList?.map((word, index) => (
                <span
                  key={index}
                  className="m-1 flex justify-between items-center text-xs bg-[#B3EBD7] rounded text-main-title py-2 px-2 hover:bg-baseColor-secondary hover:bg-opacity-50 break-words"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>
          <div className="w-full flex flex-col">
            <p className="w-full pb-2 pt-1 px-1 text-xs font-medium text-[#111537]">
              Services
            </p>
            <div className="w-full h-32 rounded-md p-1 flex flex-col border border-solid overflow-y-auto">
              {servicesList?.map((word, index) => (
                <span
                  key={index}
                  className="m-1 flex justify-between items-center text-xs bg-[#B3EBD7] rounded text-main-title py-2 px-2 hover:bg-baseColor-secondary hover:bg-opacity-50 break-words"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>
          <div className="w-full flex flex-col">
            <p className="w-full pb-2 pt-1 px-1 text-xs font-medium text-[#111537]">
              Emails
            </p>
            <div className="w-full h-32 rounded-md p-1 flex flex-col border border-solid overflow-y-auto">
              {emailsList?.map((word, index) => (
                <span
                  key={index}
                  className="m-1 flex justify-between items-center text-xs bg-[#B3EBD7] rounded text-main-title py-2 px-2 hover:bg-baseColor-secondary hover:bg-opacity-50 break-words"
                >
                  {word}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* {showPopup && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-sm font-medium mb-3">Reject Action</h2>
            <p className="text-xs mb-4">
              Are you sure you want to{" "}
              <strong className="text-red-500">Reject</strong>?
            </p>
            <label htmlFor="reason" className="text-sm font-medium mb-2 block">
              Reason: <span className="text-red-500">*</span>
            </label>
            <textarea
              id="reason"
              className={`w-full border rounded-md p-2 mb-1 text-xs ${
                reason.trim() === "" && showValidation
                  ? "border-red-500"
                  : "border-gray-300"
              }`}
              rows="4"
              value={reason}
              onChange={(e) => setReason(e.target.value)}
              placeholder="Please provide a reason"
            ></textarea>
            {reason.trim() === "" && showValidation && (
              <p className="text-red-500 text-xs mb-3">Reason is required!</p>
            )}
            <div className="flex justify-end gap-x-2">
              <button
                className="px-4 py-[7px] cursor-pointer text-xs 2xl:text-sm bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
                onClick={() => setShowPopup(false)}
              >
                Cancel
              </button>
              <button
                className="bg-[#048178] px-4 py-[7px] cursor-pointer outline-none border-none text-white rounded-md text-xs 2xl:text-sm flex items-center"
                onClick={() => {
                  if (reason.trim()) {
                    setShowValidation(false);
                    updateApprovalStatus("rejected", reason);
                  } else {
                    setShowValidation(true);
                  }
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      )}

      {showConfirm && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[25%] max-w-[50%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-sm font-medium mb-3">Alert</h2>
            <p className="text-xs mb-4">
              Are you sure! you want to{" "}
              <span className="font-semibold"> Approve? </span>
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-[7px] cursor-pointer text-xs  bg-[#E6F2F2] hover:bg-gray-300 rounded-md flex items-center mr-2 text-textColor-main"
                onClick={cancelApproval}
              >
                Cancel
              </button>
              <button
                className="bg-[#048178] px-4 py-[7px] cursor-pointer outline-none border-none text-white rounded-md text-xs flex items-center"
                onClick={confirmApproval}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )} */}
      {isPopupOpenAccess && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9998] flex justify-center items-center">
          <div className="bg-white rounded-md shadow-lg p-6 w-[40%] max-h-[80vh] overflow-y-auto relative">
            <div className="border-b border-gray-300 pb-2 mb-4">
              <h2 className="text-sm font-medium">
                Accessible Users: {data.users?.length || 0}
              </h2>
            </div>
            <button
              className="absolute top-2 right-2 text-white bg-red-600 w-6 h-6 flex items-center justify-center "
              onClick={togglePopupAccess}
            >
              ✕
            </button>

            {data.users?.length > 0 ? (
              <div className="grid grid-cols-2 gap-4">
                {data.users.map((user, index) => (
                  <div
                    key={user.userId}
                    className="bg-gray-100 rounded-md shadow p-3 flex items-center justify-center text-xs font-medium"
                  >
                    {user.userName}
                  </div>
                ))}
              </div>
            ) : (
              <p className="text-xs text-gray-500">No users available</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
export default ViewSuppliers;
